export default __webpack_public_path__ + "2f0c727c6e6e2feb0b192cd8060b88b5.png";